import React from "react";
import cx from "./cx";

const TONE_CLASS = {
    brand: 'rev-kv-row__v--brand',
    ok: 'rev-kv-row__v--ok',
    no: 'rev-kv-row__v--no',
    warn: 'rev-kv-row__v--warn',
};

/**
 * Fila clave/valor de una card resumen.
 *  - k: clave (.rev-kv-row__k)
 *  - v: valor; num=true añade .rev-num (cifras tabulares); muted=true .rev-text-muted
 *  - ruled: variante con filete inferior y tipografía de detalle (.rev-kv-row--ruled)
 *  - tone: 'brand' | 'ok' | 'no' | 'warn' — brand: gradiente de marca; resto: color semántico
 *  - children: sustituye al valor por defecto (p. ej. un chip)
 */
const RevKvRow = ({ k, v, num, muted, ruled, tone, className, children, ...rest }) => (
    <div className={cx('rev-kv-row', ruled && 'rev-kv-row--ruled', className)} {...rest}>
        <span className="rev-kv-row__k">{k}</span>
        {children !== undefined
            ? children
            : <span className={cx('rev-kv-row__v', TONE_CLASS[tone], num && 'rev-num', muted && 'rev-text-muted')}>{v}</span>}
    </div>
);

export default RevKvRow;
